<template>
  <div class="main">
    <div
      class="dropzone-container"
      @dragover="dragover"
      @dragleave="dragleave"
      @drop="drop"
      :style="isDragging && 'border-color: green;'"
    >
    <img v-if="imgs[labelFile]" :src="imgs[labelFile]" class="mr-8 rounded h-24 w-24" />

    <div class="mt-2">
     <input
        type="file"
        ref="file"
        class="hidden"
        accept="image/*, application/pdf"
        name="file"
        :id="`fileInput-${labelFile}`"
        @change="onChange"
        v-validate="{
          required: true,
          size: 2048,
        }"
        />

       <label :for="`fileInput-${labelFile}`" class="file-label">
        <div><b>{{$t('chooseFile')}}</b> {{$t('dragit')}}</div>
      </label>
    </div>
   </div>
  </div>
</template>
<style>

.main {
    align-items: center;
    justify-content: center;
    text-align: center;
    background: #fff;
    border: 1px dashed #e2e8f0;
}

.dropzone-container {
    padding: 3rem;  
}

.hidden-input {
    opacity: 0;
    overflow: hidden;
    position: absolute;
    width: 1px;
    height: 1px;
}

.file-label {
    font-size: 15px;
    cursor: pointer;
}

.preview-container {
    display: flex;
    margin-top: 2rem;
}
</style>
<script>
export default {
  data() {
    return {
      isDragging: false,
      imgs: [],
    };
  },
  props:{
    idx: {
      type: Number,
      default: null
    },
    labelFile: {
      type: String,
      default: null
    }
  },
  methods: {
    onChange(event) {
        this.selectedFile(event.target.files[0]);
        if(this.labelFile)
          this.$emit('selectedFile', this.idx, this.labelFile, event.target.files[0],'drag');
        else 
          this.$emit('selectedFile', event.target.files[0]);
    },
    dragover(e) {
      e.preventDefault();
      this.isDragging = true;
    },
    dragleave() {
      this.isDragging = false;
    },
    drop(e) {
      e.preventDefault();
      this.$refs.file.files = e.dataTransfer.files;
      this.selectedFile(this.$refs.file.files[0]);
      if(this.labelFile)
        this.$emit('selectedFile', this.idx, this.labelFile, this.$refs.file.files[0], 'drag');
      else 
        this.$emit('selectedFile', this.$refs.file.files[0]);

      this.isDragging = false;
    },

    /**
     * image validation
     */
    selectedFile(file) {
      var filePath = file.name;
      var allowedExtensions = /(\.jpg|\.jpeg|\.png|\.gif|\.pdf)$/i;
      if (!allowedExtensions.exec(filePath)) {
        this.$toasted.show(this.$t("FileUploadError"), {
          className: "top-alert",
          position: "top-center",
          type: "error",
          duration: 2000,
        });
      } else {
        this.$set(this.imgs, this.labelFile, file.type=="application/pdf"?this.$store.state.app.pdfIconUrl:URL.createObjectURL(file));
      }
    },
  },
};
</script>